import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoodNewsLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 217 193",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M114.234 176C156.069 176 189.982 142.087 189.982 100.252C189.982 58.4179 156.069 24.5044 114.234 24.5044C72.3998 24.5044 38.4863 58.4179 38.4863 100.252C38.4863 142.087 72.3998 176 114.234 176Z",
			fill: "url(#paint0_linear_590_56054)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5701 129.584L100.399 42.1831L167.52 113.153L89.5628 148.94C77.0749 154.673 63.8682 142.496 68.5701 129.584Z",
			fill: "#AEC9CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.644 69.7848C151.912 79.6589 159.382 89.448 163.969 97.2878C166.264 101.21 167.828 104.629 168.54 107.317C168.897 108.661 169.035 109.806 168.955 110.732C168.876 111.655 168.582 112.338 168.092 112.797C167.603 113.256 166.903 113.506 165.977 113.527C165.048 113.548 163.914 113.337 162.595 112.897C159.957 112.015 156.645 110.238 152.876 107.699C145.342 102.625 136.046 94.5501 126.778 84.676C117.511 74.802 110.041 65.0128 105.454 57.173C103.159 53.2509 101.595 49.8322 100.882 47.1439C100.526 45.7995 100.387 44.6545 100.467 43.729C100.547 42.8061 100.841 42.1233 101.33 41.664C101.819 41.2047 102.519 40.9545 103.446 40.9336C104.374 40.9126 105.508 41.1235 106.827 41.5641C109.465 42.4453 112.778 44.2228 116.547 46.7615C124.08 51.8359 133.377 59.9107 142.644 69.7848Z",
			fill: "#0C5661",
			stroke: "#0C5661",
			strokeWidth: .644664
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_590_56054",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 67,
			y: 42,
			width: 101,
			height: 109,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M68.5701 129.584L100.399 42.1829L167.52 113.153L89.5628 148.94C77.0749 154.672 63.8682 142.496 68.5701 129.584Z",
				fill: "#E1DCEB"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_590_56054)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M100.351 96.932C86.9031 79.3207 80.0989 58.3249 77.9043 44.2289L88.7331 42.543C90.7085 55.2312 96.9436 74.4118 109.061 90.2809C121.065 106.001 138.626 118.259 163.671 118.259V129.218C134.443 129.218 113.913 114.693 100.351 96.932Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M83.0286 122.433C69.5808 104.822 62.7766 83.8261 60.582 69.7301L71.4109 68.0442C73.3863 80.7324 79.6214 99.913 91.7389 115.782C103.742 131.502 121.304 143.76 146.349 143.76V154.72C117.12 154.72 96.5905 140.194 83.0286 122.433Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 130.029,
			cy: 136.676,
			r: 19.3399,
			fill: "#0C5661"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M137.855 130.807C138.604 131.569 138.593 132.793 137.831 133.542L128.65 142.568C127.897 143.307 126.691 143.307 125.938 142.568L122.227 138.919C121.465 138.17 121.454 136.946 122.203 136.184C122.952 135.422 124.176 135.412 124.938 136.161L127.294 138.476L135.12 130.784C135.882 130.035 137.106 130.046 137.855 130.807Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 175.802,
			cy: 67.6966,
			r: 3.86798,
			fill: "#C9E7EA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 143.569,
			cy: 27.7274,
			r: 3.86798,
			fill: "#0C5661"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.01 44.7857C150.676 43.4035 148.71 43.4035 148.376 44.7857L147.944 46.576C147.825 47.0699 147.439 47.4556 146.945 47.5748L145.155 48.007C143.773 48.3406 143.773 50.3066 145.155 50.6403L146.945 51.0724C147.439 51.1917 147.825 51.5773 147.944 52.0713L148.376 53.8616C148.71 55.2438 150.676 55.2438 151.01 53.8616L151.442 52.0713C151.561 51.5773 151.947 51.1917 152.441 51.0724L154.231 50.6403C155.613 50.3066 155.613 48.3406 154.231 48.007L152.441 47.5748C151.947 47.4556 151.561 47.0699 151.442 46.576L151.01 44.7857Z",
			fill: "#DEEDEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M134.52 15.0342C134.911 16.0282 134.422 17.1509 133.428 17.5417C130.591 18.6575 126.955 22.2513 124.527 26.7245C122.679 30.1294 121.781 33.5681 122.158 36.3823C123.294 34.7617 124.653 33.4324 126.229 32.5784C129.055 31.0476 132.28 31.2101 135.401 33.3374C138.129 35.196 139.241 37.8408 138.946 40.4761C138.665 42.9957 137.128 45.2734 135.043 46.7043C132.926 48.1566 130.116 48.8264 127.218 47.9387C125.575 47.4355 123.999 46.4625 122.556 44.9851C121.181 50.3412 121.23 57.0502 123.504 62.9839C123.886 63.9813 123.388 65.0996 122.39 65.4819C121.393 65.8641 120.274 65.3654 119.892 64.368C116.893 56.5426 117.283 47.6053 119.728 41.0961C119.659 40.9706 119.59 40.8433 119.522 40.7144C116.949 35.8572 118.489 29.7401 121.128 24.8794C123.786 19.9813 128.001 15.5194 132.013 13.9421C133.007 13.5512 134.129 14.0401 134.52 15.0342ZM124.072 40.7636C125.532 42.8385 127.048 43.8413 128.35 44.2403C129.991 44.7427 131.59 44.3823 132.854 43.5151C134.149 42.6264 134.963 41.295 135.102 40.0464C135.229 38.9134 134.833 37.6309 133.223 36.5337C131.182 35.1431 129.507 35.2022 128.072 35.9795C126.641 36.7545 125.224 38.3764 124.072 40.7636Z",
			fill: "#5C9AA4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M196.952 90.6734C176.68 83.1386 161.167 92.5078 156.15 97.807C154.926 99.0998 152.886 99.1557 151.593 97.9318C150.301 96.708 150.245 94.6679 151.468 93.3751C157.839 86.6454 175.974 75.9986 199.198 84.6306C200.867 85.2508 201.717 87.1063 201.097 88.775C200.477 90.4436 198.621 91.2936 196.952 90.6734Z",
			fill: "#228C9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M176.331 97.4469C176.783 97.2812 177.259 97.0611 177.626 96.7424C178.062 96.3638 178.239 95.8762 178.358 95.363C178.511 94.7036 178.572 94.0013 178.758 93.3408C178.826 93.0956 178.959 93.0029 179.015 92.9617C179.158 92.8578 179.303 92.83 179.439 92.8404C179.601 92.8524 179.823 92.9152 179.969 93.1933C179.989 93.2332 180.016 93.2938 180.035 93.3769C180.048 93.4378 180.056 93.6283 180.07 93.7068C180.106 93.9003 180.135 94.0937 180.162 94.2882C180.254 94.9355 180.307 95.4854 180.597 96.0801C180.99 96.8874 181.384 97.3814 181.919 97.6002C182.436 97.8118 183.054 97.772 183.843 97.6061C183.919 97.5874 183.993 97.5714 184.066 97.5583C184.415 97.4958 184.747 97.7306 184.816 98.087C184.884 98.4431 184.663 98.7902 184.318 98.8685C184.246 98.8848 184.175 98.9003 184.105 98.9144C183.038 99.1859 181.802 100.155 181.085 101.003C180.863 101.264 180.539 101.996 180.209 102.462C179.965 102.806 179.691 103.033 179.461 103.113C179.307 103.167 179.177 103.159 179.07 103.132C178.914 103.092 178.784 103.005 178.685 102.867C178.631 102.792 178.58 102.69 178.557 102.561C178.545 102.499 178.544 102.341 178.544 102.269C178.477 102.031 178.394 101.798 178.334 101.558C178.191 100.985 177.91 100.622 177.576 100.143C177.264 99.6945 176.929 99.4127 176.437 99.1877C176.373 99.1717 175.857 99.0419 175.675 98.9673C175.408 98.8581 175.281 98.675 175.235 98.5765C175.157 98.4092 175.149 98.2631 175.165 98.1413C175.188 97.9615 175.266 97.8076 175.406 97.6833C175.492 97.6061 175.621 97.531 175.794 97.4944C175.927 97.4659 176.281 97.4493 176.331 97.4469ZM179.358 96.5129C179.382 96.5676 179.407 96.6227 179.435 96.6783C180.011 97.8607 180.655 98.5209 181.438 98.8412L181.464 98.8516C180.94 99.2513 180.466 99.698 180.104 100.126C179.955 100.303 179.757 100.669 179.543 101.045C179.35 100.397 179.032 99.9387 178.634 99.3657C178.329 98.9283 178.01 98.5992 177.617 98.3309C177.922 98.1704 178.212 97.9823 178.465 97.7627C178.886 97.3969 179.165 96.9732 179.358 96.5129Z",
			fill: "#0C5661"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_590_56054",
			x1: 113.65,
			y1: -.161005,
			x2: 115.202,
			y2: 265.854,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F5F9FA" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EFEFEF"
			})]
		}) })
	]
});
export default SvgGoodNewsLight;
